var documentsToCollect = angular.module('documentsToCollect', ['classy', 'dateService', 'standardCudArray','standardModalCud', 'schoolTaxSchoolModel']);